<template>
  <div class="graphics-view" v-loading="isLoading">
    <div class="Error" v-if="isError">没有获取到相关数据</div>
    <div v-else ref="vegaView"></div>
  </div>
</template>

<script>
import api from "./api";
import * as vega from 'vega'

export default {
  name: "GraphicsView",
  data(){
    return {
      userId      : sessionStorage.getItem( 'USER_ID' ),
      isLoading   : false,
      isError     : false,
      session     : {},
      toolBoxList : []
    }
  },
  methods : {
    vegaInit(){
      this.isLoading = true;
      let _confFilePath = this.$route.query?.p || false;
      if( _confFilePath ){
        api.getVegaConfig( _confFilePath ).then( _r => {
          new vega.View( vega.parse( _r ) )
              .renderer("canvas")
              .initialize(this.$refs.vegaView )
              .hover()
              .run();
          this.isLoading = false;
        } ).catch( _e => {
          this.isError    = true;
          this.isLoading  = false;
        } )
      }else {
          this.isError    = true;
          this.isLoading  = false;
      }
    },
  },
  created() {
    this.session  = JSON.stringify( sessionStorage );
    this.vegaInit();
  }
}
</script>

<style lang="less" scoped>
.graphics-view{
  height:100vh;
  width:100vw;
}
.Error{
  margin-top: 200px;
  text-align: center;
  font-weight: bold;
  color:#E6A23C;
  font-size:20px;
}
</style>
